import { render } from "./StatsInteractionsCount.vue?vue&type=template&id=6ba48e55"
import script from "./StatsInteractionsCount.vue?vue&type=script&lang=js"
export * from "./StatsInteractionsCount.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fae/dev/grazer/grazer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__